import styles from './VServicesModalRepairOrder.module.css'
import { useState } from 'react';
// Form
import { useForm } from "react-hook-form"
// Radix UI
import * as RadioGroup from '@radix-ui/react-radio-group';
// Processing Modal
import VProcessingPayment from "../processing/VProcessingPayment";

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
import Modal_1 from "../../../../common/Modals/Modal_1";

const VServicesModalRepairOrder = () => {
    const [activeTab, setActiveTab] = useState('individual'); // 'individual' or 'company'
    const [paymentMethod, setPaymentMethod] = useState('RoboKassa');

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
        allowScroll()
        modal.close()
    } 

    const { register, formState: { errors }, handleSubmit, setValue, watch, reset } = useForm({
        defaultValues: {
            // Физическое лицо / Контактное лицо (одинаковые поля)
            firstName: '',
            lastName: '',
            phone: '',
            // Юридическое лицо
            organizationName: '',
            bin: '',
            // Физ лицо - адрес
            city: "Алматы",
            street: '',
            building: '',
            apartment: '',
            entrance: '',
            floor: '',
            // Общие поля
            amount: '',
            comment: ''
        }
    });

    const selectedCity = watch("city");

    // Больше не нужно очищать поля при переключении вкладок
    // Одинаковые поля (firstName, lastName, phone) остаются синхронными

    const onSubmit = (data) => {
        let formData = {
            clientType: activeTab,
            paymentMethod: paymentMethod,
            amount: data.amount,
            comment: data.comment
        };

        if (activeTab === 'individual') {
            // Физическое лицо - добавляем личные данные и адрес
            formData = {
                ...formData,
                firstName: data.firstName,
                lastName: data.lastName,
                phone: data.phone,
                city: data.city,
                street: data.street,
                building: data.building,
                apartment: data.apartment,
                entrance: data.entrance,
                floor: data.floor
            };
        } else if (activeTab === 'company') {
            // Юридическое лицо - добавляем данные организации и контактного лица
            formData = {
                ...formData,
                organizationName: data.organizationName,
                bin: data.bin,
                firstName: data.firstName,  // теперь это контактное лицо
                lastName: data.lastName,    // теперь это контактное лицо  
                phone: data.phone
            };
        }

        console.log('Закрываем текущее окно и открываем окно обработки платежа');
        
        // НЕ сбрасываем форму здесь - только после успешной оплаты
        
        // Закрываем текущее модальное окно
        closeModal();
        
        // Открываем модальное окно обработки платежа с данными заказа и функцией сброса
        setTimeout(() => {
            blockScroll();
            Modal_1.open(VProcessingPayment, { 
                orderData: formData,
                onSuccess: () => {
                    // Сбрасываем форму только при успехе
                    reset();
                }
            });
        }, 100);
    }

    const places = [
        "71 переезд",
        "Акжар", 
        "Алатау",
        "Алматы",
        "Ашибулак",
        "Белбулак",
        "Бесагаш",
        "Боралдай",
        "Водник",
        "Гульдала",
        "Даму",
        "Даулет",
        "Жанатурмыс",
        "Жетыген",
        "Заречный",
        "Каскелен",
        "Коксай",
        "Комсомол",
        "Кошмамбет",
        "Кунаев",
        "Кыргауылды",
        "Мерей",
        "Панфилов",
        "Талгар",
        "Талдыбулак",
        "Таусамал",
        "Туздыбастау",
        "Ыргелы"
    ]

    const ListOfPlaces = () => places.map( (place, i) => {
        return <option key={place} value={place}>{place}</option>
    }) 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Ремонт питьевых аппаратов</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                    >
                        &#9587;
                    </button>
                </div>

                {/* TABS */}
                <div className={styles.tabs_container}>
                    <button 
                        className={`${styles.tab} ${activeTab === 'individual' ? styles.tab_active : ''}`}
                        onClick={() => setActiveTab('individual')}
                    >
                        Физ. лицо
                    </button>
                    <button 
                        className={`${styles.tab} ${activeTab === 'company' ? styles.tab_active : ''}`}
                        onClick={() => setActiveTab('company')}
                    >
                        Юр. лицо
                    </button>
                </div>

                {/* FORM */}
                <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                    {/* Данные клиента */}
                    <div className={styles.section}>
                        {activeTab === 'individual' ? (
                            // Физическое лицо
                            <>
                                <label className={styles.addCityLabel + (errors.firstName ? ` ${styles.error}` : "")}>Имя*:</label>
                                <input 
                                    key="individual-firstName"
                                    className={styles.addStreet + (errors.firstName ? ` ${styles.error}` : "")} 
                                    {...register("firstName", { required: activeTab === 'individual' })} 
                                />

                                <label className={styles.addCityLabel + (errors.lastName ? ` ${styles.error}` : "")}>Фамилия*:</label>
                                <input 
                                    key="individual-lastName"
                                    className={styles.addStreet + (errors.lastName ? ` ${styles.error}` : "")} 
                                    {...register("lastName", { required: activeTab === 'individual' })} 
                                />

                                <label className={styles.addCityLabel + (errors.phone ? ` ${styles.error}` : "")}>Телефон*:</label>
                                <input 
                                    key="individual-phone"
                                    className={styles.addStreet + (errors.phone ? ` ${styles.error}` : "")} 
                                    {...register("phone", { required: true })} 
                                    placeholder="+7 (___) ___-__-__"
                                />
                            </>
                        ) : (
                            // Юридическое лицо
                            <>
                                <label className={styles.addCityLabel + (errors.organizationName ? ` ${styles.error}` : "")}>Наименование организации*:</label>
                                <input 
                                    key="company-organizationName"
                                    className={styles.addStreet + (errors.organizationName ? ` ${styles.error}` : "")} 
                                    {...register("organizationName", { required: activeTab === 'company' })} 
                                    placeholder="Введите наименование организации"
                                />

                                <label className={styles.addCityLabel + (errors.bin ? ` ${styles.error}` : "")}>БИН*:</label>
                                <input 
                                    key="company-bin"
                                    className={styles.addStreet + (errors.bin ? ` ${styles.error}` : "")} 
                                    {...register("bin", { required: activeTab === 'company' })} 
                                    placeholder="Введите БИН"
                                />

                                <h4 className={styles.subsection_title}>Контактное лицо</h4>
                                
                                <label className={styles.addCityLabel + (errors.firstName ? ` ${styles.error}` : "")}>Имя*:</label>
                                <input 
                                    key="company-firstName"
                                    className={styles.addStreet + (errors.firstName ? ` ${styles.error}` : "")} 
                                    {...register("firstName", { required: activeTab === 'company' })} 
                                    placeholder="Имя"
                                />

                                <label className={styles.addCityLabel + (errors.lastName ? ` ${styles.error}` : "")}>Фамилия*:</label>
                                <input 
                                    key="company-lastName"
                                    className={styles.addStreet + (errors.lastName ? ` ${styles.error}` : "")} 
                                    {...register("lastName", { required: activeTab === 'company' })} 
                                    placeholder="Фамилия"
                                />

                                <label className={styles.addCityLabel + (errors.phone ? ` ${styles.error}` : "")}>Телефон*:</label>
                                <input 
                                    key="company-phone"
                                    className={styles.addStreet + (errors.phone ? ` ${styles.error}` : "")} 
                                    {...register("phone", { required: true })} 
                                    placeholder="Введите номер телефона"
                                />
                            </>
                        )}
                    </div>

                    {/* Адрес - только для физического лица */}
                    {activeTab === 'individual' && (
                        <div className={styles.section}>
                            <h3 className={styles.section_title}>Адрес</h3>
                            
                            {/* Город, Улица */}
                            <div className={styles.address_info_container}>
                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel}>Город*:</label>
                                    <select
                                        key="individual-city"
                                        value={selectedCity}
                                        className={styles.addCitySelect}
                                        {...register("city")}
                                        onChange={(e) => setValue("city", e.target.value)}
                                    >
                                        <ListOfPlaces />
                                    </select>
                                </div>

                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel + (errors.street ? ` ${styles.error}` : "")}>Улица*:</label>
                                    <input 
                                        key="individual-street"
                                        className={styles.addStreet + (errors.street ? ` ${styles.error}` : "")} 
                                        {...register("street", { required: activeTab === 'individual' })} 
                                    />
                                </div>
                            </div>

                            {/* Дом, Кв/офис */}
                            <div className={styles.address_info_container}>
                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel + (errors.building ? ` ${styles.error}` : "")}>Дом*:</label>
                                    <input 
                                        key="individual-building"
                                        className={styles.addStreet + (errors.building ? ` ${styles.error}` : "")} 
                                        {...register("building", { required: activeTab === 'individual' })} 
                                    />
                                </div>

                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel}>Кв/офис:</label>
                                    <input 
                                        key="individual-apartment"
                                        className={styles.addStreet}
                                        {...register("apartment")} 
                                    />
                                </div>
                            </div>

                            {/* Подъезд, Этаж */}
                            <div className={styles.address_info_container}>
                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel}>Подъезд:</label>
                                    <input 
                                        key="individual-entrance"
                                        className={styles.addStreet}
                                        {...register("entrance")} 
                                    />
                                </div>

                                <div className={styles.address_info_block}>
                                    <label className={styles.addCityLabel}>Этаж:</label>
                                    <input 
                                        key="individual-floor"
                                        className={styles.addStreet}
                                        {...register("floor")} 
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Сумма */}
                    <div className={styles.section}>
                        <label className={styles.addCityLabel + (errors.amount ? ` ${styles.error}` : "")}>Сумма*:</label>
                        <input 
                            key="amount"
                            type="number"
                            inputMode="numeric"
                            className={styles.addStreet + (errors.amount ? ` ${styles.error}` : "")} 
                            {...register("amount", { required: "Поле сумма обязательно для заполнения", min: { value: 1, message: "Сумма должна быть больше 0" } })} 
                            placeholder="Введите сумму"
                        />
                    </div>

                    {/* Комментарий */}
                    <div className={styles.section}>
                        <label className={styles.addCityLabel}>Комментарий:</label>
                        <textarea 
                            key="comment"
                            className={styles.addCommentText}
                            {...register("comment")} 
                            placeholder="Дополнительная информация"
                        />
                    </div>

                    {/* Способ оплаты */}
                    <div className={styles.section}>
                        <h3 className={styles.section_title}>Способ оплаты</h3>
                        <RadioGroup.Root 
                            className={styles.RadioGroupRoot} 
                            aria-label="select payment method"
                            onValueChange={setPaymentMethod}
                            value={paymentMethod}
                            name='payment_method'
                        >
                            {/* RoboKassa */}
                            <div className={styles.payment_option}>
                                <div className={styles.radioGroupBlock}>
                                    <RadioGroup.Item className={styles.radioGroupItem} value="RoboKassa" id="paymentRobokassa">
                                        <RadioGroup.Indicator className={styles.radioGroupIndicator} />
                                    </RadioGroup.Item>
                                    <label className={styles.payment_label} htmlFor="paymentRobokassa">
                                        <span className={styles.payment_text}>RoboKassa</span>
                                    </label>
                                </div>
                            </div>
                        </RadioGroup.Root>
                    </div>

                    <div className={styles.btn_block}>
                        <button 
                            type="button" 
                            onClick={closeModal} 
                            className={styles.item_btn_blue_border}
                        >
                            Отмена
                        </button>
                        <button 
                            type="submit" 
                            className={styles.item_btn_blue_filled}
                        >
                            Оплатить
                        </button>
                    </div>
                </form>
            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalRepairOrder;